<template>
    <dashboard-layout>
        <div>

            <div class="d-md-flex justify-content-between align-items-center mb-1">
                <h3 class="mb-0">Open textbook</h3>
            </div>

            <h5 class="mt-3 mb-2">Index</h5>


            <div class="tags">
                <router-link
                    :to="{'name' : 'book_specialties.index' , params: { 'subscribe_id': $route?.params?.subscribe_id, 'book_id' : item.id }}"
                    class="btn btn-soft-secondary" v-for="item in items?.data" :key="item.id">
                    {{ item?.name }}
                </router-link>
            </div>

            <Bootstrap5Pagination
                class="mb-0"
                :data="items"
                :limit="2"
                :show-disabled="false"
                :size="'default'"
                :align="'center'"
                @pagination-change-page="getResults"
            />

        </div>
    </dashboard-layout>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();

export default {
    components: {
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            q: this.$route.query,
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('books', {
                params: {
                    'page': page,
                    // 'name': this.q.name,
                    'subscribe_id': this.$route?.params?.subscribe_id,
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;

                // this.$router.replace({name: "books.index", query: {'page': page, 'name': this.q.name}});
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
    }
}
</script>

<style>
.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.badge {
    cursor: pointer;
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: white;
    border-radius: 0.25rem;
}

.badge:hover {
    background-color: #0056b3;
}
</style>
